import styled from 'styled-components';

export const SelectItem = styled.div`
    width: 100%;
    height: 30px;
    position: relative;
    color: #c8c8c8;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding-left: 5px;
    font-weight: 300;
    font-size: 14px;

    &:hover {
        font-weight: bold;
    }

    transition: all 0.1s;
`;

export const SelectItemCheckMarkContainer = styled.div`
    width: 20px;
    margin-right: 8px;
`;



// WEBPACK FOOTER //
// ./src/UI/Components/Items/SelectItems/style.js